var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"id":"custom-logout-btn"},on:{"click":function($event){return _vm.kakaoLogout()}}},[_vm._v("카카오 로그아웃 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }